/* ============================================================================
   CATÁLOGO EN PDF
   ---------------------------------------------------------------------------
   Un solo generador para todas las pantallas: detalle de pedido, detalle de
   factura, inventario, nuevo pedido y mercancía por llegar.

   El formato es siempre el mismo — cabecera con logo, diez fichas por página
   en dos columnas, pie con paginación — y lo que cambia es el título y los
   campos que el usuario haya marcado.

   Se carga jsPDF bajo demanda: son 350 KB que no hacen falta hasta que
   alguien pulsa "Generar PDF".
============================================================================ */

var CAT_LIB_URL = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
var _catLibProm = null;

function catCargarLib(){
  if(window.jspdf && window.jspdf.jsPDF) return Promise.resolve();
  if(_catLibProm) return _catLibProm;
  _catLibProm = new Promise(function(res, rej){
    var s = document.createElement('script');
    s.src = CAT_LIB_URL;
    s.onload = function(){ res(); };
    s.onerror = function(){ _catLibProm = null; rej(new Error('No se pudo cargar el generador de PDF')); };
    document.head.appendChild(s);
  });
  return _catLibProm;
}


// ── Los campos que puede llevar cada ficha ────────────────────────────────
// 'k' es la clave interna, 'label' lo que se ve, y 'get' saca el valor del
// artículo. Se separan en filas de 2, 4 y hasta 5 celdas para que la ficha
// quede como el modelo.
var CAT_CAMPOS = [
  // El barcode no es una celda de la tabla: se dibuja abajo como imagen.
  // Esta aqui solo para que la casilla del usuario lo active o lo quite.
  // Lleva etiqueta aunque no sea una fila de la tabla: el panel previo a
  // generar lista TODOS los campos, y sin texto salia una casilla en blanco
  // que nadie relacionaba con el codigo de barras. `fila:0` ya se encarga de
  // que no se imprima como renglon; se dibuja abajo como imagen.
  {k:'barcode',    label:'C\u00f3digo de barras', fila:0, get:function(){ return ''; }},
  {k:'categoria',  label:'Categor\u00eda',  fila:1, get:function(a){ return a.grupo || a.dept || ''; }},
  {k:'marca',      label:'Marca',           fila:1, get:function(a){ return a.marca || ''; }},

  {k:'packing',    label:'Pzs/caja',        fila:2, get:function(a){ return a.unidadesbulto || a.salpackun || ''; }},
  {k:'medida',     label:'Medida',          fila:2, get:function(a){ return a.u_tamano || a.tamano || _catCar(a, ['tamano','tama','medida','size','dimens']); }},
  {k:'cbm',        label:'Cubicaje',        fila:2, get:function(a){
    // Primero la ficha tecnica: ahi el cubicaje viene ya calculado y con su
    // unidad ("1.01 Pies"). La columna 'volumen' suele estar en 0, y por eso
    // el catalogo mostraba 0 en todos los articulos.
    var f = _catCar(a, ['cubicaje','cxblt','cbm','volumen']);
    if(f) return f;
    var v = Number(a.volumen)||0;
    return v ? ((Math.round(v*100000)/100000) + ' Pies') : '';
  }},
  {k:'peso',       label:'Peso',            fila:2, get:function(a){
    var p = Number(a.peso)||0;
    if(p) return p + ' kg';
    return _catCar(a, ['peso producto','peso','weight']);
  }},

  {k:'color',      label:'Color',           fila:3, get:function(a){ return a.u_color || a.color || _catCar(a, ['color','colour']); }},
  {k:'disponible', label:'Disponible',      fila:3, col:[12,74,124],
   get:function(a){ return a.disponible!=null ? Number(a.disponible).toLocaleString('es') : ''; }},
  {k:'porllegar',  label:'Por llegar',      fila:3, col:[180,83,9],
   get:function(a){ return a.por_llegar ? Number(a.por_llegar).toLocaleString('es') : ''; }},
  {k:'eta',        label:'ETA',             fila:3, col:[12,68,124],
   get:function(a){ return a.eta ? catFechaCorta(a.eta) : ''; }},
  {k:'precio',     label:'Precio',          fila:3, col:[22,101,52],
   get:function(a){ return (Number(a.precio)||0) ? fmt(a.precio) : ''; }},

  // El codigo arancelario (Customs Group de SAP). Se imprime el nombre, que es
  // lo que entiende el cliente; el codigo va detras entre parentesis para
  // aduana. Si un articulo no lo tiene en SAP, la celda sale vacia.
  {k:'arancel',    label:'Arancel',         fila:4, get:function(a){
    // El CODIGO, que es lo que se declara en aduana ("001.324.348"). Si el
    // articulo no lo tiene, se cae al nombre del grupo antes que dejarlo vacio.
    var c=(a.arancel_cod!=null && a.arancel_cod!=='') ? String(a.arancel_cod).trim() : '';
    return c || String(a.arancel||'').trim()
             || _catCar(a, ['arancel','partida','customs','aduana']);
  }},
  // El pais de origen. Vive en las caracteristicas del articulo ('Porigen'
  // en esta base), no como columna.
  // La medida de la CAJA (OITM.U_CartonSize), no la del articulo. Se busca
  // por 'cartonsize' y no por 'tamano', que es la del producto.
  {k:'tamanobulto',label:'Tama\u00f1o bulto',   fila:2, get:function(a){
    return _catCar(a, ['cartonsize','carton size','tamanobulto','tamano bulto',
                       'tamano de bulto','medida bulto']);
  }},
  {k:'origen',     label:'Origen',          fila:4, get:function(a){
    var v=_catCar(a, ['porigen','origen','procedencia','pais','country','made']);
    // El codigo de dos letras se cambia por el nombre del pais: en un catalogo
    // que ve el cliente, "CN" no dice nada y "CHINA" si.
    try{ if(v && typeof r2Pais==='function') return r2Pais(v,'es'); }catch(e){}
    return String(v||'').toUpperCase();
  }},
  {k:'composicion',label:'Composici\u00f3n', fila:4, get:function(a){ return _catCar(a, ['composic','compo','material','tela','fabric','content','hecho','confeccion']); }},
  {k:'tipo',       label:'Tipo',            fila:4, get:function(a){
    // subg es un CODIGO (164, 313...). subgLabel lo traduce al nombre que se
    // ve en el portal; sin eso salia el numero en el catalogo.
    if(a.subg && typeof subgLabel === 'function'){
      var n = subgLabel(a.subg);
      if(n && String(n) !== String(a.subg)) return n;
    }
    return _catCar(a, ['tipo','tipoproducto','categoria']) || a.subg || '';
  }},
  {k:'cantidad',   label:'Cantidad',        fila:4, col:[22,101,52],
   get:function(a){ return a.cantidad!=null ? Number(a.cantidad).toLocaleString('es') : ''; }},
  {k:'total',      label:'Total',           fila:4, col:[22,101,52],
   get:function(a){ return (Number(a.total)||0) ? fmt(a.total) : ''; }}
];

// 'caracteristicas' es un JSON con lo que no cabe en columnas. Las claves
// varian mucho ('composicion', 'compo', 'material', 'tela'...), asi que se
// reutiliza rptCarac, que es la misma busqueda que usa la ficha del
// articulo y ya esta probada contra los datos reales.
function _catCar(a, claves){
  var c = a && a.caracteristicas;
  if(!c) return '';
  var lista = Array.isArray(claves) ? claves : [claves];
  if(typeof rptCarac === 'function'){
    try{ return rptCarac(c, lista) || ''; }catch(e){}
  }
  // Respaldo, por si rptCarac no estuviera cargada
  if(typeof c === 'string'){ try{ c = JSON.parse(c); }catch(e){ return ''; } }
  if(typeof c !== 'object') return '';
  var norm = function(x){
    return String(x).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  };
  for(var i=0;i<lista.length;i++){
    var b = norm(lista[i]);
    var k = Object.keys(c).find(function(x){ return norm(x).indexOf(b) === 0; });
    if(k && String(c[k]||'').trim()) return String(c[k]);
  }
  return '';
}

function catFechaCorta(v){
  var s = String(v||'').substring(0,10);
  if(!/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  var p = s.split('-');
  return p[2]+'/'+p[1]+'/'+p[0].slice(2);
}


// ── El logo, para la cabecera ─────────────────────────────────────────────
var _catLogo = null;
async function catLogo(){
  if(_catLogo !== null) return _catLogo;
  try{
    var url = (typeof LOGO_URL !== 'undefined' && LOGO_URL) ? LOGO_URL : null;
    if(!url){ _catLogo = false; return false; }
    var img = await new Promise(function(res, rej){
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function(){ res(i); };
      i.onerror = rej;
      i.src = url;
    });
    var c = document.createElement('canvas');
    c.width = img.naturalWidth; c.height = img.naturalHeight;
    c.getContext('2d').drawImage(img, 0, 0);
    _catLogo = {data: c.toDataURL('image/png'), w: img.naturalWidth, h: img.naturalHeight};
  }catch(e){ _catLogo = false; }
  return _catLogo;
}


// ── Cabecera: barra gris con logo, título y fecha ─────────────────────────
function catCabecera(doc, W, logo, pag, nItems, titulo, subtitulo){
  var M=30, h=44, y=26;
  doc.setFillColor(78,78,78);
  doc.rect(M, y, W-M*2, h, 'F');

  if(logo){
    var ih=24, iw=ih*(logo.w/logo.h);
    doc.setFillColor(255,255,255);
    doc.roundedRect(M+7, y+(h-ih-10)/2, iw+16, ih+10, 3, 3, 'F');
    try{ doc.addImage(logo.data,'PNG', M+15, y+(h-ih)/2, iw, ih); }catch(e){}
  } else {
    doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(255,255,255);
    doc.text('KENNEDY CENTER', M+14, y+h/2+4);
  }

  doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(255,255,255);
  doc.text(String(titulo||'CAT\u00c1LOGO').toUpperCase(), W/2, y+h/2+4, {align:'center'});

  doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(70,70,70);
  var f=new Date();
  var fecha=('0'+f.getDate()).slice(-2)+'/'+('0'+(f.getMonth()+1)).slice(-2)+'/'+f.getFullYear();
  // El subtitulo dice de QUE es el catalogo: pedido 1234, factura 5678...
  // Sin eso, al ver el PDF suelto no se sabe que se genero.
  var linea = (pag===1 ? ('Items: '+nItems+'   \u00b7   ') : '')
            + (subtitulo ? (subtitulo + '   \u00b7   ') : '') + fecha;
  doc.text(linea, W/2, y+h+16, {align:'center'});
}


// ── Pie: barra negra con la nota y la paginación ──────────────────────────
function catPie(doc, W, H, pag, totPag, nota){
  var M=30, h=26, y=H-M-h+6;
  doc.setFillColor(17,17,17);
  doc.rect(M, y, W-M*2, h, 'F');
  doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor(225,225,225);
  doc.text(nota || 'Kennedy Center Corp.  \u00b7  Precios y disponibilidad sujetos a cambio sin previo aviso.',
           M+12, y+h/2+2.5);
  doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor(255,255,255);
  doc.text('P\u00e1gina '+pag+' de '+totPag, W-M-12, y+h/2+3, {align:'right'});
}


// ── Una fila de la ficha: títulos arriba, valores abajo ───────────────────
// Las celdas se reparten el ancho por igual. El texto que no cabe se recorta
// en vez de desbordar: así una composición larguísima no descuadra la ficha.
// Alto de cada fila: 7pt de titulo + 8.5 de valor. Compacto a proposito,
// para que quepan las tres filas en una ficha de 120pt como en el modelo.
var CAT_FILA_H = 15.5;

function catTabla(doc, x, y, w, celdas){
  if(!celdas.length) return y;
  var n=celdas.length, cw=w/n, hT=7, hV=CAT_FILA_H-hT;
  doc.setLineWidth(0.4); doc.setDrawColor(160,160,160);
  doc.setFillColor(241,240,236);
  doc.rect(x, y, w, hT, 'FD');
  doc.rect(x, y+hT, w, hV, 'D');
  for(var i=1;i<n;i++) doc.line(x+cw*i, y, x+cw*i, y+CAT_FILA_H);

  celdas.forEach(function(c,i){
    doc.setFont('helvetica','normal'); doc.setFontSize(5.2); doc.setTextColor(95,95,95);
    var t=String(c.t||'');
    while(t && doc.getTextWidth(t)>cw-3) t=t.slice(0,-1);
    doc.text(t, x+cw*i+cw/2, y+4.9, {align:'center'});

    var col=c.c||[25,25,25];
    doc.setTextColor(col[0],col[1],col[2]);
    var v=String(c.v==null?'':c.v).replace(/\s+/g,' ').trim();

    // Antes se recortaban letras hasta que cupiera, y un valor como
    // "68*86*1" salia a medias. Ahora se REDUCE la letra hasta 4pt, que
    // sigue leyendose, y solo si aun asi no entra se parte en dos lineas.
    var tam = 6.6, ancho = cw - 4;
    doc.setFont('helvetica','bold');
    doc.setFontSize(tam);
    while(tam > 4 && doc.getTextWidth(v) > ancho){
      tam -= 0.3;
      doc.setFontSize(tam);
    }

    if(doc.getTextWidth(v) > ancho){
      // Ni al minimo cabe: dos lineas, mas pequenas y juntas.
      doc.setFontSize(4.2);
      var lineas = doc.splitTextToSize(v, ancho).slice(0, 2);
      doc.text(lineas, x+cw*i+cw/2, y+11.2, {align:'center', lineHeightFactor:1.05});
    } else {
      doc.text(v||'\u2014', x+cw*i+cw/2, y+13.2, {align:'center'});
    }
    doc.setFontSize(6.6);
  });
  return y+CAT_FILA_H;
}


// ── Una ficha completa ────────────────────────────────────────────────────
// El alto es FIJO. Todo lo que pueda crecer —descripción, composición— se
// recorta, para que una ficha larga no empuje a las demás y se mantengan las
// diez por página.
function catFicha(doc, a, x, y, cw, ch, campos, fotos){
  doc.setDrawColor(25,25,25); doc.setLineWidth(0.9);
  doc.rect(x, y, cw, ch, 'D');

  var lw = fotos ? cw*0.52 : cw;      // con foto, la ficha ocupa la mitad

  // El código, arriba a la izquierda
  doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(15,15,15);
  var cod=String(a.itemcode||'');
  while(cod && doc.getTextWidth(cod)>lw-14) cod=cod.slice(0,-1);
  doc.text(cod, x+7, y+14);

  // La descripción, centrada y en dos líneas como máximo
  doc.setFont('helvetica','bold'); doc.setFontSize(7); doc.setTextColor(35,35,35);
  var desc=doc.splitTextToSize(String(a.itemname||a.dscription||''), lw-14);
  doc.text(desc.slice(0,2), x+lw/2, y+25, {align:'center'});

  // Las filas de campos, solo con lo que el usuario marcó.
  //
  // El alto de la ficha es fijo, asi que se dibuja hasta donde cabe y lo que
  // sobra se descarta. Si no, la ultima fila se sale por abajo y pisa el
  // codigo de barras de la ficha siguiente.
  var ty=y+36;
  // El barcode se pinta solo si esta entre los campos marcados. Antes salia
  // siempre que el articulo tuviera codigo, aunque se desmarcara la casilla.
  var quiereBc = campos.some(function(c){ return c.k === 'barcode'; });
  var conBarras = quiereBc && !!String(a.codebars||'').trim();
  var libre = ch - 36 - 4;
  if(conBarras) libre -= 24;
  var filasCaben = Math.max(1, Math.floor(libre / CAT_FILA_H));
  var tope = y + 36 + filasCaben * CAT_FILA_H;

  // TODOS los campos marcados, en el orden en que se definieron. Antes iban
  // repartidos en filas fijas y, si una se llenaba, el resto se perdia sin
  // avisar: marcabas trece campos y salian siete.
  var todas = campos.filter(function(c){ return c.fila !== 0; })
    .map(function(c){
      var v = c.get(a);
      return (v==null || v==='') ? null : {t:c.label, v:v, c:c.col};
    }).filter(Boolean);

  // La composicion va SOLA en su fila, a lo ancho: es un texto largo
  // ("PELO: 100% POLIPROPILENO RESP: 100% YUTE SINTETICO") que en una celda
  // estrecha quedaba ilegible o desaparecia.
  var comp = null;
  for(var ci=0; ci<todas.length; ci++){
    if(todas[ci].t && /composici/i.test(todas[ci].t)){
      comp = todas.splice(ci, 1)[0];
      break;
    }
  }

  // El resto se reparte entre las filas disponibles, lo mas parejo posible.
  // Hasta 5 por fila: mas se vuelven ilegibles.
  var reservaComp = comp ? CAT_FILA_H : 0;
  if(todas.length){
    var disp = Math.max(1, Math.floor((tope - ty - reservaComp) / CAT_FILA_H));
    var nFilas = Math.min(disp, Math.ceil(todas.length / 5));
    var porFila = Math.ceil(todas.length / nFilas);
    if(porFila > 5) porFila = 5;
    for(var f=0; f<nFilas && todas.length; f++){
      ty = catTabla(doc, x+7, ty, lw-14, todas.splice(0, porFila));
    }
  }
  if(comp && (ty + CAT_FILA_H) <= tope){
    ty = catTabla(doc, x+7, ty, lw-14, [comp]);
  }

  // La foto, a la derecha
  if(fotos && a._foto){
    var fx = x+lw+4, fw = cw-lw-11, fh = ch-20;
    try{ doc.addImage(a._foto, 'JPEG', fx, y+10, fw, fh, undefined, 'FAST'); }
    catch(e){
      try{ doc.addImage(a._foto, 'PNG', fx, y+10, fw, fh, undefined, 'FAST'); }catch(e2){}
    }
  }

  // El código de barras, abajo
  // Las barras: solo si el usuario las marco Y quedo sitio bajo la ultima
  // fila. Antes se pintaban siempre, con o sin la casilla puesta.
  var bc = (conBarras && (y + ch - ty) >= 24) ? String(a.codebars).trim() : '';
  if(bc){
    var bi=catBarcode(bc);
    if(bi){
      var bw=Math.min(lw-42, 120), bh=16;
      try{ doc.addImage(bi,'PNG', x+7+((lw-14)-bw)/2, ch+y-26, bw, bh); }catch(e){}
      doc.setFont('helvetica','normal'); doc.setFontSize(5.8); doc.setTextColor(70,70,70);
      doc.text(bc, x+7+(lw-14)/2, ch+y-6, {align:'center'});
    }
  }
}


// ── Código de barras EAN-13 ───────────────────────────────────────────────
// Dibujado a mano en un canvas: es solo un patrón de barras y evita cargar
// otra librería. Si el código no es válido, no se pinta nada.
var _catBcCache = {};
var _BC_L = ['0001101','0011001','0010011','0111101','0100011',
             '0110001','0101111','0111011','0110111','0001011'];
var _BC_G = ['0100111','0110011','0011011','0100001','0011101',
             '0111001','0000101','0010001','0001001','0010111'];
var _BC_R = ['1110010','1100110','1101100','1000010','1011100',
             '1001110','1010000','1000100','1001000','1110100'];
var _BC_PAR = ['LLLLLL','LLGLGG','LLGGLG','LLGGGL','LGLLGG',
               'LGGLLG','LGGGLL','LGLGLG','LGLGGL','LGGLGL'];

function catBarcode(code){
  var c = String(code||'').replace(/\D/g,'');
  if(c.length !== 13) return null;
  if(_catBcCache[c]) return _catBcCache[c];

  var bits = '101';
  var par = _BC_PAR[+c[0]];
  for(var i=1;i<=6;i++) bits += (par[i-1]==='L' ? _BC_L[+c[i]] : _BC_G[+c[i]]);
  bits += '01010';
  for(var j=7;j<=12;j++) bits += _BC_R[+c[j]];
  bits += '101';

  var cv = document.createElement('canvas');
  cv.width = bits.length; cv.height = 40;
  var ctx = cv.getContext('2d');
  ctx.fillStyle = '#fff'; ctx.fillRect(0,0,cv.width,cv.height);
  ctx.fillStyle = '#000';
  for(var k=0;k<bits.length;k++) if(bits[k]==='1') ctx.fillRect(k,0,1,40);

  _catBcCache[c] = cv.toDataURL('image/png');
  return _catBcCache[c];
}


// ── Las fotos, reducidas para que el PDF no pese de más ───────────────────
// 300 px de ancho es de sobra para el tamaño al que salen impresas, y evita
// que un catálogo de 200 artículos acabe pesando 80 MB.
async function catFoto(a){
  try{
    if(!a.picturname && !a.foto_url) return null;

    var _fp = window._KCC_FOTOPAIR || (typeof fotoPair==='function' ? fotoPair : null);
    if(!_fp) return null;
    var pp = _fp(a.picturname||'', a.foto_url||'');

    // Todas las candidatas, no solo la primera: los nombres del bucket varian
    // en mayusculas y extension, y por eso muchas fotos que SI se ven en
    // pantalla no salian en el PDF.
    var urls = [];
    if(pp && pp.primary) urls.push(pp.primary);
    if(pp && pp.fb) urls = urls.concat(String(pp.fb).split('|').filter(Boolean));
    if(a.foto_url && urls.indexOf(a.foto_url) < 0) urls.push(a.foto_url);
    if(!urls.length) return null;

    for(var i=0; i<urls.length; i++){
      var img = await _catBajarFoto(urls[i]);
      if(img) return img;
    }
    return null;
  }catch(e){ return null; }
}

// Se descarga con fetch y se convierte con createImageBitmap. Cargarla en un
// <img> con crossOrigin fallaba en silencio cuando el servidor no daba
// permiso CORS: el canvas quedaba bloqueado y no salia nada. Este camino ya
// lo probamos con las miniaturas del modo sin conexion y funciona.
async function _catBajarFoto(url){
  try{
    var r = await fetch(url, {mode:'cors', cache:'force-cache'});
    if(!r.ok) return null;
    var blob = await r.blob();
    if(!blob || !blob.size) return null;

    var m = 300;    // de sobra para el tamano al que sale impresa
    var w, h, dibujar;

    if(window.createImageBitmap){
      var bmp = await createImageBitmap(blob);
      w = bmp.width; h = bmp.height;
      dibujar = function(ctx, aw, ah){ ctx.drawImage(bmp, 0, 0, aw, ah); };
    } else {
      var img = await new Promise(function(res, rej){
        var i = new Image();
        i.onload = function(){ res(i); };
        i.onerror = rej;
        i.src = URL.createObjectURL(blob);
      });
      w = img.naturalWidth; h = img.naturalHeight;
      dibujar = function(ctx, aw, ah){ ctx.drawImage(img, 0, 0, aw, ah); };
    }

    if(w > m || h > m){
      if(w > h){ h = Math.round(h*m/w); w = m; } else { w = Math.round(w*m/h); h = m; }
    }
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
    dibujar(ctx, w, h);
    return c.toDataURL('image/jpeg', 0.72);
  }catch(e){ return null; }
}


// ════════════════════════════════════════════════════════════════════
//  EL GENERADOR
//  articulos : lista con itemcode, itemname y lo que lleve cada campo
//  opciones  : {titulo, subtitulo, campos:['marca','precio'...], fotos, nota, archivo}
// ════════════════════════════════════════════════════════════════════
async function catalogoPDF(articulos, opciones){
  opciones = opciones || {};
  if(!articulos || !articulos.length){ alert('No hay art\u00edculos que incluir.'); return; }

  var aviso = catAviso('Preparando el PDF\u2026');
  try{
    await catCargarLib();
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({unit:'pt', format:'letter'});
    var W = doc.internal.pageSize.getWidth();
    var H = doc.internal.pageSize.getHeight();

    var marcados = opciones.campos || ['categoria','marca','packing','medida','color','precio'];
    var campos = CAT_CAMPOS.filter(function(c){ return marcados.indexOf(c.k) >= 0; });
    var fotos = opciones.fotos !== false;

    // Las fotos, antes de empezar a dibujar
    var conFoto = 0;
    if(fotos){
      for(var i=0;i<articulos.length;i++){
        aviso.texto('Preparando fotos\u2026 ' + (i+1) + ' de ' + articulos.length);
        articulos[i]._foto = await catFoto(articulos[i]);
        if(articulos[i]._foto) conFoto++;
      }
      // Si no se logro NINGUNA hay algo mal (permisos, red, nombres): mejor
      // decirlo que entregar un catalogo mudo.
      if(!conFoto && articulos.length){
        console.warn('[catalogo] ninguna foto pudo cargarse');
      }
    }

    var logo = await catLogo();

    // La cuadrícula: 2 columnas x 5 filas = 10 por página, como el modelo.
    var M=30, COLS=2, FILAS=5;
    var yIni = 26+44+26;                       // debajo de la cabecera
    var yFin = H-M-26-4;                       // encima del pie
    var gap = 8;
    var cw = (W-M*2-gap)/COLS;
    var ch = (yFin-yIni-gap*(FILAS-1))/FILAS;

    var porPag = COLS*FILAS;
    var totPag = Math.ceil(articulos.length/porPag);

    for(var p=0; p<totPag; p++){
      if(p>0) doc.addPage();
      aviso.texto('Dibujando p\u00e1gina ' + (p+1) + ' de ' + totPag + '\u2026');
      catCabecera(doc, W, logo, p+1, articulos.length, opciones.titulo, opciones.subtitulo);

      var trozo = articulos.slice(p*porPag, (p+1)*porPag);
      trozo.forEach(function(a, ix){
        var col = ix % COLS, fila = Math.floor(ix / COLS);
        catFicha(doc, a, M + col*(cw+gap), yIni + fila*(ch+gap), cw, ch, campos, fotos);
      });

      catPie(doc, W, H, p+1, totPag, opciones.nota);
    }

    doc.save(opciones.archivo || ('Catalogo_' + hoyLocal() + '.pdf'));
    aviso.cerrar();
    if(fotos && !conFoto && articulos.length){
      alert('El cat\u00e1logo sali\u00f3 sin fotos.\n\n'
        + 'Ninguna imagen pudo cargarse. Suele ser porque los art\u00edculos '
        + 'no tienen foto en el servidor, o por falta de conexi\u00f3n.');
    }
  }catch(e){
    aviso.cerrar();
    alert('No se pudo generar el PDF: ' + (e.message || e));
  }
}


// Un aviso de progreso: generar 200 fichas con foto lleva su tiempo y sin
// esto parece que el portal se ha colgado.
function catAviso(txt){
  var d = document.createElement('div');
  d.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10050;'
    +'display:flex;align-items:center;justify-content:center';
  d.innerHTML='<div style="background:var(--surface,#fff);border-radius:13px;padding:22px 30px;'
    +'text-align:center;min-width:260px">'
    +'<div class="spinner" style="margin:0 auto 12px"></div>'
    +'<div id="cat-aviso-txt" style="font-size:13.5px">'+txt+'</div></div>';
  document.body.appendChild(d);
  return {
    texto: function(t){ var e=document.getElementById('cat-aviso-txt'); if(e) e.textContent=t; },
    cerrar: function(){ d.remove(); }
  };
}


// ════════════════════════════════════════════════════════════════════
//  PANEL PREVIO
//  Antes de generar: elegir campos, revisar los artículos y ajustar
//  precios. Para la mercancía por llegar el precio se propone desde el
//  CIF, porque muchas veces todavía no tiene precio de venta.
// ════════════════════════════════════════════════════════════════════
var CAT_PANEL = null;

// El precio sugerido: el doble del CIF, redondeado hacia arriba a múltiplos
// de 10 centavos. 3.58 -> 7.16 -> 7.20
function catPrecioSugerido(cif){
  var c = Number(cif)||0;
  if(!c) return 0;
  return Math.ceil(c * 2 * 10) / 10;
}

function catPanel(articulos, opciones){
  opciones = opciones || {};
  if(!articulos || !articulos.length){ alert('No hay art\u00edculos.'); return; }

  // Cada artículo con su precio propuesto y marcado para incluir
  CAT_PANEL = {
    articulos: articulos.map(function(a){
      var pv = Number(a.precio || a.precioventa) || 0;
      var cif = Number(a.cif) || 0;
      return Object.assign({}, a, {
        _inc: true,
        _precio: pv || catPrecioSugerido(cif),
        _cif: cif,
        _auto: !pv && !!cif        // se marca el que viene calculado
      });
    }),
    opciones: opciones
  };

  var prev = document.getElementById('cat-panel'); if(prev) prev.remove();
  var m = document.createElement('div');
  m.id = 'cat-panel';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10000;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:1000px;'
    +'width:100%;max-height:93vh;display:flex;flex-direction:column">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);display:flex;'
      +'align-items:center;gap:10px;flex-wrap:wrap">'
      +'<b style="flex:1;font-size:15px">\u{1F4D6} Armar cat\u00e1logo</b>'
      +'<span id="cat-panel-n" style="font-size:12.5px;color:var(--text3)"></span>'
      +'<button onclick="catPanelCerrar()" style="border:none;background:none;font-size:23px;'
        +'cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div style="flex:1;overflow-y:auto;padding:16px 18px">'
      +'<div style="font-size:11px;color:var(--text3);text-transform:uppercase;'
        +'letter-spacing:.4px;margin-bottom:7px">Campos del cat\u00e1logo</div>'
      +'<div id="cat-panel-campos" style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:16px"></div>'
      +'<div id="cat-panel-precios"></div>'
      +'<div id="cat-panel-tabla"></div>'
    +'</div>'
    +'<div style="padding:13px 18px;border-top:1px solid var(--border);display:flex;'
      +'gap:8px;align-items:center;flex-wrap:wrap">'
      +'<label style="display:flex;align-items:center;gap:6px;font-size:12.5px;cursor:pointer">'
        +'<input type="checkbox" id="cat-panel-fotos" checked> Incluir fotos</label>'
      +'<span style="flex:1"></span>'
      +'<button class="btn btn-sm" onclick="catPanelCerrar()">Cancelar</button>'
      +'<button class="btn btn-sm btn-p" onclick="catPanelGenerar()">\u{1F4C4} Generar PDF</button>'
    +'</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) catPanelCerrar(); });

  catPanelCampos();
  catPanelPrecios();
  catPanelTabla();
}

function catPanelCerrar(){
  var m=document.getElementById('cat-panel'); if(m) m.remove();
  CAT_PANEL = null;
}

function catPanelCampos(){
  var c = document.getElementById('cat-panel-campos'); if(!c) return;
  var pre = (CAT_PANEL.opciones.campos)
    || ['categoria','marca','packing','medida','color','precio'];
  c.innerHTML = CAT_CAMPOS.map(function(f){
    return '<label style="display:flex;align-items:center;gap:6px;font-size:12.5px;cursor:pointer;'
      +'padding:6px 10px;border:1px solid var(--border);border-radius:8px">'
      +'<input type="checkbox" class="cat-campo" value="'+f.k+'"'
      +(pre.indexOf(f.k)>=0?' checked':'')+'>'+npEsc(f.label)+'</label>';
  }).join('');
}

// ── Los precios ───────────────────────────────────────────────────────────
// La regla por defecto es el doble del CIF, pero se puede cambiar el factor
// y volver a aplicarlo a todos de golpe. Cada precio queda editable.
function catPanelPrecios(){
  var c = document.getElementById('cat-panel-precios'); if(!c) return;
  var conCif = CAT_PANEL.articulos.filter(function(a){ return a._cif > 0; }).length;
  if(!conCif){ c.innerHTML=''; return; }

  c.innerHTML =
     '<div style="background:var(--surface2,#F7F7F8);border-radius:10px;padding:11px 13px;'
      +'margin-bottom:14px;display:flex;gap:10px;align-items:center;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:190px">'
        +'<div style="font-size:12.5px;font-weight:600">Precio desde el CIF</div>'
        +'<div style="font-size:11.5px;color:var(--text3);margin-top:2px">'
        +conCif+' art\u00edculo(s) sin precio de venta. Se propone el CIF por el factor, '
        +'redondeado hacia arriba a 10 c\u00e9ntimos.</div>'
      +'</div>'
      +'<label style="font-size:12.5px;display:flex;align-items:center;gap:6px">Factor'
        +'<input type="number" id="cat-factor" value="2" min="0.1" step="0.1" '
        +'style="width:68px;padding:6px 8px;border:1px solid var(--border);border-radius:7px;'
        +'font-size:13px;text-align:right"></label>'
      +'<button class="btn btn-sm" onclick="catPanelAplicar()">Aplicar a todos</button>'
    +'</div>';
}

function catPanelAplicar(){
  var f = Number((document.getElementById('cat-factor')||{}).value) || 2;
  CAT_PANEL.articulos.forEach(function(a){
    if(a._cif > 0) a._precio = Math.ceil(a._cif * f * 10) / 10;
  });
  catPanelTabla();
}

function catPanelTabla(){
  var c = document.getElementById('cat-panel-tabla'); if(!c) return;
  var A = CAT_PANEL.articulos;
  var n = A.filter(function(a){ return a._inc; }).length;
  var lbl = document.getElementById('cat-panel-n');
  if(lbl) lbl.textContent = n + ' de ' + A.length + ' seleccionados';

  var hayCif = A.some(function(a){ return a._cif > 0; });

  c.innerHTML =
     '<div style="display:flex;gap:8px;margin-bottom:8px;flex-wrap:wrap">'
      +'<button class="btn btn-sm" onclick="catPanelTodos(true)">Marcar todos</button>'
      +'<button class="btn btn-sm" onclick="catPanelTodos(false)">Desmarcar todos</button>'
    +'</div>'
    +'<div style="max-height:340px;overflow-y:auto"><table class="tbl">'
    +'<tr><th style="width:34px"></th><th>SKU</th><th>Descripci\u00f3n</th>'
    + (hayCif ? '<th style="text-align:right">CIF</th>' : '')
    +'<th style="text-align:right">Precio</th></tr>'
    + A.map(function(a, i){
        return '<tr'+(a._inc?'':' style="opacity:.45"')+'>'
          +'<td><input type="checkbox"'+(a._inc?' checked':'')
            +' onchange="catPanelMarcar('+i+',this.checked)"></td>'
          +'<td style="font-size:11.5px"><b>'+npEsc(String(a.itemcode||''))+'</b></td>'
          +'<td style="font-size:11.5px">'+npEsc(String(a.itemname||a.dscription||'').substring(0,52))+'</td>'
          + (hayCif
              ? ('<td style="text-align:right;font-size:11.5px;color:var(--text3)">'
                 +(a._cif?fmt(a._cif):'\u2014')+'</td>')
              : '')
          +'<td style="text-align:right">'
            +'<input type="number" value="'+(Number(a._precio)||0).toFixed(2)+'" step="0.01" min="0" '
            +'onchange="catPanelPrecio('+i+',this.value)" '
            +'style="width:88px;padding:4px 7px;border:1px solid var(--border);border-radius:6px;'
            +'font-size:12.5px;text-align:right'
            +(a._auto?';background:#ECFDF5':'')+'">'
          +'</td></tr>';
      }).join('')
    +'</table></div>'
    + (A.some(function(a){ return a._auto; })
        ? ('<div style="font-size:11.5px;color:var(--text3);margin-top:9px">'
           +'Los precios en verde se calcularon desde el CIF porque el art\u00edculo '
           +'a\u00fan no tiene precio de venta.</div>')
        : '');
}

function catPanelMarcar(i, v){ CAT_PANEL.articulos[i]._inc = !!v; catPanelTabla(); }
function catPanelTodos(v){
  CAT_PANEL.articulos.forEach(function(a){ a._inc = !!v; });
  catPanelTabla();
}
function catPanelPrecio(i, v){
  CAT_PANEL.articulos[i]._precio = Number(v)||0;
  CAT_PANEL.articulos[i]._auto = false;    // ya no es automatico: lo puso alguien
}

async function catPanelGenerar(){
  if(!CAT_PANEL) return;
  var campos = Array.prototype.slice
    .call(document.querySelectorAll('.cat-campo:checked'))
    .map(function(x){ return x.value; });
  var fotos = (document.getElementById('cat-panel-fotos')||{}).checked !== false;

  var lista = CAT_PANEL.articulos.filter(function(a){ return a._inc; })
    .map(function(a){ return Object.assign({}, a, {precio: a._precio}); });

  if(!lista.length){ alert('No has marcado ning\u00fan art\u00edculo.'); return; }

  var op = Object.assign({}, CAT_PANEL.opciones, {campos:campos, fotos:fotos});
  catPanelCerrar();
  await catalogoPDF(lista, op);
}


// ════════════════════════════════════════════════════════════════════
//  LOS BOTONES DE CADA PANTALLA
//  Cada uno arma su lista y le pone título y subtítulo propios, para que
//  al abrir el PDF suelto se sepa de qué documento salió.
// ════════════════════════════════════════════════════════════════════

// Trae del inventario los datos que la ficha necesita y que el documento
// de origen no tiene: medidas, color, composición, foto...
var _catAvisado = false;
async function catCompletar(codigos){
  var info = {};
  _catAvisado = false;
  for(var i=0;i<codigos.length;i+=200){
    var trozo = codigos.slice(i,i+200);
    var inList = trozo.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    try{
      // Una sola columna inexistente hace que PostgREST rechace la consulta
      // ENTERA y el catalogo salga vacio. Por eso se piden en dos tandas:
      // primero las que el portal ya usa sin problemas, y aparte las que
      // pueden no estar. Si la segunda falla, se pierden esos campos pero
      // el catalogo sale.
      // Los nombres reales de la tabla. El color y el tamano llevan prefijo
      // u_ (campos de usuario de SAP), y la composicion, el tipo y el
      // cubicaje no son columnas: viven dentro de 'caracteristicas', que es
      // un JSON.
      var sel = 'select=itemcode,itemname,precioventa,disponible,unidadesbulto,'
              + 'marca,grupo,subg,codebars,picturname,foto_url,peso,volumen,'
              + 'u_color,u_tamano,u_nentrada,caracteristicas,salpackun,cif,fob';
      // El CIF solo para quien puede verlo: en el catalogo de un vendedor no
      // debe viajar ni aunque no se pinte.
      if(typeof veCompras==='function' && veCompras()) sel += ',cif,fob';
      var r = await q('inventario', sel+'&itemcode=in.('+inList+')&limit='+trozo.length);
      (r||[]).forEach(function(x){ info[x.itemcode]=x; });

      // El codigo arancelario, en su PROPIA consulta. Es una columna reciente
      // y si todavia no esta en la tabla, PostgREST responde 400 y se perderia
      // todo lo de arriba. Asi, como mucho, se queda sin arancel.
      try{
        var ar = await q('inventario',
          'select=itemcode,arancel,arancel_cod&itemcode=in.('+inList+')&limit='+trozo.length);
        (ar||[]).forEach(function(x){
          var d=info[x.itemcode];
          if(d){ d.arancel=x.arancel; d.arancel_cod=x.arancel_cod; }
        });
      }catch(e){}

    }catch(e){
      // Sin esto, un fallo aqui deja el catalogo con las fichas vacias y
      // parece que el portal ignora los campos marcados.
      console.error('[catalogo] no pude leer el inventario:', e);
      if(!_catAvisado){
        _catAvisado = true;
        alert('No se pudieron leer los datos del inventario:\n\n'
          + String(e.message||e).slice(0,180)
          + '\n\nEl cat\u00e1logo saldr\u00e1 incompleto.');
      }
    }
  }
  return info;
}

// Traduce las casillas de cada pantalla a los campos del catálogo. Las
// pantallas usan sus propias claves ('sku', 'stock', 'packing'...) y aquí
// los campos se llaman de otra forma.
var CAT_EQUIV = {
  precio:'precio', stock:'disponible', packing:'packing', marca:'marca',
  tipo:'tipo', tamano:'medida', composicion:'composicion', cubicaje:'cbm',
  color:'color', peso:'peso', barcode:'barcode', sku:null, foto:null,
  arancel:'arancel',
  origen:'origen',
  tamanobulto:'tamanobulto',
  bultos:null, grupo:'categoria', categoria:'categoria'
};

function catCamposDe(cols){
  var out = [];
  (cols||[]).forEach(function(c){
    var k = CAT_EQUIV[c.k || c];
    if(k && out.indexOf(k) < 0) out.push(k);
  });
  // La categoría y la marca van siempre: son lo que identifica el artículo
  // de un vistazo y sin ellas la ficha queda coja.
  if(out.indexOf('categoria') < 0) out.unshift('categoria');
  if(out.indexOf('marca') < 0) out.splice(1, 0, 'marca');
  return out;
}

// ── Inventario ────────────────────────────────────────────────────────────
async function catDesdeInventario(){
  // invExportFetch trae TODO lo que cumple el filtro actual, no solo la
  // pagina que se ve. Es la misma via que usa el Excel del inventario.
  var av = catAviso('Reuniendo los art\u00edculos\u2026');
  try{
    var filas = (typeof invExportFetch==='function') ? await invExportFetch() : null;
    av.cerrar();
    if(!filas || !filas.length){
      alert('No hay art\u00edculos con los filtros puestos.');
      return;
    }
    // Los campos que el usuario marcó en la propia pantalla
    var cols = (typeof invExpCols==='function') ? invExpCols() : [];
    await catalogoPDF(filas.map(function(a){
      return Object.assign({}, a, {precio: a.precioventa});
    }), {
      titulo: 'CAT\u00c1LOGO',
      subtitulo: 'Inventario',
      campos: catCamposDe(cols),
      fotos: cols.some(function(c){ return c.k === 'foto'; }),
      archivo: 'Catalogo_inventario_' + hoyLocal() + '.pdf'
    });
  }catch(e){
    av.cerrar();
    alert('No se pudo preparar: ' + (e.message || e));
  }
}

// ── Detalle de pedido ─────────────────────────────────────────────────────
async function catDesdePedido(docnum, lineas){
  if(!lineas || !lineas.length){ alert('El pedido no tiene l\u00edneas.'); return; }
  var av = catAviso('Reuniendo los art\u00edculos\u2026');
  try{
    var info = await catCompletar(lineas.map(function(l){ return l.itemcode; }));
    var lista = lineas.map(function(l){
      var i = info[l.itemcode] || {};
      return Object.assign({}, i, {
        itemcode: l.itemcode,
        itemname: l.dscription || i.itemname,
        cantidad: l.quantity,
        precio: l.price,
        total: l.linetotal
      });
    });
    av.cerrar();
    await catalogoPDF(lista, {
      titulo: 'PEDIDO ' + docnum,
      subtitulo: 'Pedido ' + docnum,
      // Los campos que el usuario marcó en la pantalla. 'pdc-' es el prefijo
      // de las casillas del detalle de pedido y factura.
      campos: catCamposDoc(),
      fotos: catQuiereFotos(),
      archivo: 'Pedido_' + docnum + '.pdf',
      nota: 'Kennedy Center Corp.  \u00b7  Pedido ' + docnum
    });
  }catch(e){ av.cerrar(); alert('No se pudo preparar: '+(e.message||e)); }
}

// ── Detalle de factura ────────────────────────────────────────────────────
async function catDesdeFactura(docnum, lineas){
  if(!lineas || !lineas.length){ alert('La factura no tiene l\u00edneas.'); return; }
  var av = catAviso('Reuniendo los art\u00edculos\u2026');
  try{
    var info = await catCompletar(lineas.map(function(l){ return l.itemcode; }));
    var lista = lineas.map(function(l){
      var i = info[l.itemcode] || {};
      return Object.assign({}, i, {
        itemcode: l.itemcode,
        itemname: l.dscription || i.itemname,
        cantidad: l.quantity,
        precio: l.price,
        total: l.linetotal
      });
    });
    av.cerrar();
    await catalogoPDF(lista, {
      titulo: 'FACTURA ' + docnum,
      subtitulo: 'Factura ' + docnum,
      // Los campos que el usuario marcó en la pantalla. 'pdc-' es el prefijo
      // de las casillas del detalle de pedido y factura.
      campos: catCamposDoc(),
      fotos: catQuiereFotos(),
      archivo: 'Factura_' + docnum + '.pdf',
      nota: 'Kennedy Center Corp.  \u00b7  Factura ' + docnum
    });
  }catch(e){ av.cerrar(); alert('No se pudo preparar: '+(e.message||e)); }
}

// ── Nuevo pedido (la cotización que se está armando) ──────────────────────
async function catDesdeCarrito(){
  if(typeof npLineas==='undefined' || !npLineas.length){
    alert('La cotizaci\u00f3n est\u00e1 vac\u00eda.');
    return;
  }
  var av = catAviso('Reuniendo los art\u00edculos\u2026');
  try{
    var info = await catCompletar(npLineas.map(function(l){ return l.itemcode; }));
    var lista = npLineas.map(function(l){
      var i = info[l.itemcode] || {};
      return Object.assign({}, i, {
        itemcode: l.itemcode,
        itemname: l.itemname || i.itemname,
        cantidad: l.quantity,
        precio: l.price,
        total: (Number(l.quantity)||0) * (Number(l.price)||0)
      });
    });
    av.cerrar();
    var cli = (typeof npCli!=='undefined' && npCli) ? npCli.cardname : '';
    await catalogoPDF(lista, {
      titulo: 'COTIZACI\u00d3N',
      subtitulo: cli || 'Cotizaci\u00f3n',
      // Los campos marcados en Nuevo pedido, cuyas casillas llevan 'npc-'.
      campos: catCamposDoc('npc-'),
      fotos: catQuiereFotos('npc-'),
      archivo: 'Cotizacion_' + hoyLocal() + '.pdf',
      nota: 'Kennedy Center Corp.  \u00b7  Cotizaci\u00f3n' + (cli ? (' \u00b7 ' + cli) : '')
    });
  }catch(e){ av.cerrar(); alert('No se pudo preparar: '+(e.message||e)); }
}


// ── Mercancía por llegar ──────────────────────────────────────────────────
// Se puede armar el catálogo de todo lo filtrado o de un grupo concreto —un
// departamento, un mes, una entrada—. El precio suele faltar porque la
// mercancía aún no ha llegado, así que se propone desde el CIF.
async function catDesdePorLlegar(clave, docnums){
  var filas = (typeof PL_ROWS !== 'undefined' && PL_ROWS) ? PL_ROWS : [];
  if(!filas.length){ alert('No hay mercanc\u00eda por llegar cargada.'); return; }

  var deQue = 'Mercanc\u00eda por llegar';

  // Por entradas: una o varias ordenes de compra juntas.
  if(docnums && docnums.length){
    var set = {};
    docnums.forEach(function(d){ set[String(d)] = 1; });
    filas = filas.filter(function(r){ return set[String(r.docnum)]; });
    if(!filas.length){ alert('Esas entradas no tienen art\u00edculos.'); return; }
    deQue = docnums.length === 1 ? 'Una entrada' : (docnums.length + ' entradas');
  }
  // O por grupo de la lista (departamento, mes...)
  else if(clave){
    var g = _plGrupos(filas);
    filas = (g[clave] && g[clave].items) || [];
    if(!filas.length){ alert('Ese grupo no tiene art\u00edculos.'); return; }
    deQue = String(clave);
  }

  var av = catAviso('Reuniendo los art\u00edculos\u2026');
  try{
    var codes = [];
    var vis = {};
    filas.forEach(function(r){
      if(r.itemcode && !vis[r.itemcode]){ vis[r.itemcode]=1; codes.push(r.itemcode); }
    });
    var info = await catCompletar(codes);

    var lista = codes.map(function(code){
      var i = info[code] || {};
      // Se suma lo que viene de TODAS las lineas de ese articulo: puede estar
      // repartido en varias ordenes de compra.
      var pend = 0, eta = null;
      filas.forEach(function(r){
        if(r.itemcode !== code) return;
        pend += Number(r.pend)||0;
        var f = String(r.fecha||'').substring(0,10);
        if(f && (!eta || f < eta)) eta = f;    // la primera llegada
      });
      // El coste: el CIF del articulo o, si no lo tiene, el precio de la
      // orden de compra. Sirve para proponer precio de venta aunque el
      // articulo aun no tenga uno.
      var costo = 0;
      filas.forEach(function(r){
        if(r.itemcode === code && !costo) costo = Number(r.precio) || 0;
      });
      return Object.assign({}, i, {
        itemcode: code,
        itemname: i.itemname || code,
        por_llegar: pend,
        eta: eta,
        cif: Number(i.cif) || costo,
        precio: Number(i.precioventa) || 0
      });
    });
    av.cerrar();

    catPanel(lista, {
      titulo: 'CAT\u00c1LOGO',
      subtitulo: deQue,
      // Los que el usuario haya marcado en la pantalla, mas los propios de
      // la mercancia en transito.
      campos: (function(){
        var base = (typeof invExpCols==='function') ? catCamposDe(invExpCols())
                 : ['categoria','marca','packing','medida','color'];
        ['porllegar','eta','precio'].forEach(function(k){
          if(base.indexOf(k) < 0) base.push(k);
        });
        return base;
      })(),
      archivo: 'Catalogo_por_llegar_' + hoyLocal() + '.pdf',
      nota: 'Kennedy Center Corp.  \u00b7  Mercanc\u00eda en tr\u00e1nsito. '
          + 'Precios y disponibilidad sujetos a cambio sin previo aviso.'
    });
  }catch(e){ av.cerrar(); alert('No se pudo preparar: '+(e.message||e)); }
}


// ── Los campos marcados en el detalle de pedido y factura ─────────────────
// Esas pantallas usan casillas con el prefijo 'pdc-'. Antes los campos
// estaban fijos en el código y daba igual lo que se marcara.
// El prefijo de las casillas cambia segun la pantalla: 'pdc-' en el detalle de
// pedido y de factura, 'npc-' en Nuevo pedido. Estaba fijo en 'pdc-', asi que
// desde Nuevo pedido no encontraba NINGUNA casilla y el PDF salia con los
// campos por defecto en vez de los marcados.
//
// Ojo: no vale detectar cual existe en el DOM. go() solo cambia clases, asi
// que las casillas de TODAS las pantallas estan siempre presentes; hay que
// decirle cual es.
function catCamposDoc(prefijo){
  var pre = prefijo || 'pdc-';
  var cols = (typeof colsFromPrefix === 'function') ? colsFromPrefix(pre) : [];
  var out = catCamposDe(cols);
  // Cantidad y total van siempre en un pedido o una factura: son el motivo
  // del documento.
  ['cantidad','total'].forEach(function(k){
    if(out.indexOf(k) < 0) out.push(k);
  });
  return out;
}

function catQuiereFotos(prefijo){
  var cb = document.getElementById((prefijo||'pdc-')+'foto');
  return cb ? !!cb.checked : true;
}
